import { refreshManagerService } from "@/business/shared/session/infrastructure/services/refreshManagerService";

export const manageRefreshProcess = {
  busyProcess(): void {
    refreshManagerService.busy();
  },
  freeProcess(): void {
    refreshManagerService.free();
  },
};
